<template>
	<!-- 级联题 -->
	<div @click="setEditIndex(index)">
		<p v-if="isBankViewTest" class="my-bank-tag">{{$t('main.CascadeQuestions')}}</p>
		<el-row :gutter="10" class="question-box">
			<el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">{{ question.quesIndex + 1 }}</el-col>
			<el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title" @click="setActiveInput(question.qid)">
				<span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{ question.questionsName }}</span>

				<TitleEditor
					:isTest="true"
					v-if="!isBankViewTest"
					class="outline-none"
					:qid="question.qid"
					:class="question.qid"
					:value="question.questionsName"
                    :actionTitleEditorShow="activeInputId === question.qid"
					@childValueChange="
						val => {
							question.questionsName = val;
						}
					"
				></TitleEditor>
			</el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<OperateWrap
					style="display: flex;
						width: 100%;
						justify-content: end;
					"
					:bankId="$route.query.bankId"	
					:question="question"
				></OperateWrap>
			</el-col>
		</el-row>

		<el-row :gutter="10" style="margin-top: 12px !important;margin-bottom: 14px">
			<div style="margin-left: 50px;">
				<!-- <el-cascader v-model="value" :options="question.optionList" @change="handleChange">
				</el-cascader> -->
				<el-select :popper-append-to-body="false" class="selectLeft" v-model="levelOneId" :placeholder="$t('main.PleaseSelect')" @change="oneChange">
					<el-option :label="question.optionPlaceholder1" value=" "></el-option>
					<el-option v-for="item in question.optionList" :key="item.id" :label="item.label" :value="item.value + '_' + item.id"></el-option>
				</el-select>

				<el-select :popper-append-to-body="false" class="selectLeft" v-model="levelTwoId" :placeholder="$t('main.PleaseSelect')" @change="twoChange">
					<el-option :label="question.optionPlaceholder2" value=" "></el-option>
					<el-option v-for="item in levelTwoOptionList" :key="item.id" :label="item.label" :value="item.value + '_' + item.id"></el-option>
				</el-select> 

				<el-select :popper-append-to-body="false" v-if="levelThreeOptionList.length > 0" class="selectLeft" v-model="levelThreeId" :placeholder="$t('main.PleaseSelect')" @change="ThreeChange">
					<el-option :label="question.optionPlaceholder3" value=" "></el-option>
					<el-option v-for="item in levelThreeOptionList" :key="item.id" :label="item.label" :value="item.value + '_' + item.id"></el-option>
				</el-select>

				<el-select :popper-append-to-body="false" v-if="levelFourOptionList.length > 0" class="selectLeft" v-model="levelFourId" :placeholder="$t('main.PleaseSelect')">
					<el-option :label="question.optionPlaceholder4" value=" "></el-option>
					<el-option v-for="item in levelFourOptionList" :key="item.id" :label="item.label" :value="item.value + '_' + item.id"></el-option>
				</el-select>
				<div style="margin-top: 10px;" v-if="inputShow"><el-input style="width: 200px;" v-model="input" :placeholder="$t('main.PleaseEnterContent')"></el-input></div>
			</div>
		</el-row>

		<el-row :gutter="10" style="margin-top: 12px !important" v-if="question.isedit && !isBankViewTest">
			<el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="el_item_option item_container_title" style="margin-left: 50px">
				<i class="el-icon-edit el-icon-common" @click="openEditOptions">{{$t('main.EditingOptions')}}</i>
				<!-- <i class="el-icon-folder-add el-icon-common" @click="upladData">导入选项</i> -->
			</el-col>
		</el-row>
		<cascadeCascadingEditOptions :question="question" ref="cascadeCascadingEditOptions"></cascadeCascadingEditOptions>
		<uploadData ref="uploadData" @uploadDataOk="uploadDataOk"></uploadData>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TitleEditor from '@/components/titleEditor/titleEditor.vue';
import cascadeCascadingEditOptions from './cascadeCascadingEditOptions/index';
import uploadData from './cascadeCascadingEditOptions/uploadData';
import OperateWrap from "./collectToBank/operateaWrap.vue"
export default {
	components: {
		TitleEditor,
		cascadeCascadingEditOptions,
		uploadData,
		OperateWrap
	},
	props: {
		question: {},
		editIndex: { type: Number, default: 0 },
		index: { type: Number, default: 0 },
		isExistPage: { type: Boolean, default: false },
		editOptionIndex: { type: String, default: '0_0' },
		questionList: {
			type: Array,
			default: () => []
		},
		// 管理题库时查看试题 只可以删除
		isBankViewTest: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			inputShow: false,
			input: '',
			levelTwoOptionList: [],
			levelThreeOptionList: [],
			levelFourOptionList: [],
			levelOneId: '',
			levelTwoId: '',
			levelThreeId: '',
			levelOneIdText: '',
			levelTwoIdText: '',
			levelThreeIdText: '',
			levelFourId: '',
		};
	},
	computed: {
		...mapState(['activeInputId']),
	},
	created() {
		console.log('查询', this.question.optionList);
	},
	methods: {
		...mapActions(['setActiveInput']),
		uploadDataOk(value) {
			console.log('查询', this.question);
			console.log('查询', value);
			this.question.optionList = value;
		},
		upladData() {
			this.$refs.uploadData.openUpload();
		},
		oneChange(value) {
			this.levelOneId = value.split('_')[0];
			this.levelOneIdText = value.split('_')[1];
			this.levelTwoId = '';
			this.levelTwoOptionList = [];
			this.levelThreeId = '';
			this.levelThreeOptionList = [];
			this.levelFourId = '';
			this.levelFourOptionList = [];
			this.question.optionList.forEach(item => {
				if (this.levelOneIdText == item.id) {
					this.levelTwoOptionList = item.children;
				}
				if (item.type == 2) {
					this.inputShow = ture;
				}
			});
		},
		twoChange(value) {
			this.levelTwoId = value.split('_')[0];
			this.levelTwoIdText = value.split('_')[1];
			this.levelThreeId = '';
			this.levelThreeOptionList = [];
			this.levelFourId = '';
			this.levelFourOptionList = [];
			this.question.optionList.forEach(item => {
				if (this.levelOneIdText == item.id) {
					item.children.forEach(item2 => {
						if (this.levelTwoIdText == item2.id) {
							this.levelThreeOptionList = item2.children;
						}
						if (item2.type == 2) {
							this.inputShow = ture;
						}
					});
				}
			});
		},
		ThreeChange(value) {
			console.log(value);
			this.levelThreeId = value.split('_')[0];
			this.levelThreeIdText = value.split('_')[1];
			this.levelFourId = '';
			this.levelFourOptionList = [];
			this.question.optionList.forEach(item => {
				if (this.levelOneIdText == item.id) {
					item.children.forEach(item2 => {
						if (this.levelTwoIdText == item2.id) {
							item2.children.forEach(item3 => {
								if (this.levelThreeIdText == item3.id) {
									this.levelFourOptionList = item3.children;
								}
								if (item3.type == 2) {
									this.inputShow = ture;
								}
							});
						}
					});
				}
			});
		},
		handleChange(value) {
			console.log(value);
		},
		openEditOptions() {
			this.$refs.cascadeCascadingEditOptions.dialogVisible = true;
		},
		setEditIndex(index) {
			this.$emit('setEditIndex', index);
		},
	}
};
</script>

<style lang="scss" scoped>
.selectLeft {
	width: 120px;
	margin-left: 10px;
}
.selectLeft:first-child {
	margin-left: 0px;
}
.el_item_option {
	line-height: 40px;
	// height: 44px;
}
.el-icon-common {
	margin-right: 23px;
	font-size: 16px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}
</style>
